<div class="flex justify-between px-20 pt-15 pb-5 mt-45">
  <h3>Job Notifications</h3>
  <div class="flex">
    <button matButton="elevated" class="charcoal-button" (click)="subscribeToEvents()">
      {{ locationAdminStore.emailSubscriptionEvents().length ? 'EDIT SUBSCRIPTION' : 'SUBSCRIBE' }}
    </button>
    @if (locationAdminStore.emailSubscriptionEvents().length) {
      <div class="secondary-icon">
        <button matIconButton [matMenuTriggerFor]="subscriptionMenu" (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #subscriptionMenu="matMenu" class="kebab-menu">
          <button mat-menu-item (click)="unsubscribeEvents()">Unsubscribe</button>
        </mat-menu>
      </div>
    }
  </div>
</div>
<mat-divider />
<div class="flex flex-col px-20 pb-0 pt-10 gap-y-10">
  @if (!locationAdminStore.emailSubscriptionEvents().length) {
    <infos-guidance class="mt-10 -mb-10 w-full" [guidanceTemplate]="guidance" />
  }

  @if (locationAdminStore.emailSubscriptionEvents().length) {
    <div class="flex items-start gap-x-20">
      <span class="whitespace-nowrap mt-[8px]">Send to: </span>
      <mdc-list-chips [options]="locationAdminStore.emailSubscriptionRecipients()" />
    </div>
    <div class="grid grid-cols-5 gap-20">
      @for (event of locationAdminStore.emailSubscriptionEvents(); track event) {
        <mat-card class="flex flex-row! items-center gap-x-10 p-20">
          <mat-icon svgIcon="notification_outline" />
          <span class="subtitle-1 text-charcoal">
            {{ event | humanize | titlecase }}
          </span>
        </mat-card>
      }
    </div>
  }
</div>

<ng-template #guidance>
  <div class="text-dove-gray text-[16px]">
    You are not subscribed to any notifications. To receive e-mail notifications for job events, click on the subscribe
    button.
  </div>
</ng-template>
